import { render } from "./GameAidsPanel.vue?vue&type=template&id=138ef93b&scoped=true"
import script from "./GameAidsPanel.vue?vue&type=script&lang=js"
export * from "./GameAidsPanel.vue?vue&type=script&lang=js"

import "./GameAidsPanel.vue?vue&type=style&index=0&id=138ef93b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138ef93b"]])

export default __exports__